/**
 * @surfline/quiver-react v9.0.1 2020-04-10
 */

import React$1 from 'react';
import 'prop-types';
import 'core-js/modules/es.array.map';
import 'core-js/modules/es.string.split';
import 'core-js/modules/es.array.slice';
import { formatArticleDate } from '@surfline/web-common';

/* istanbul ignore next */

const formatBasinText = basin => basin.split('_').map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' ');

const SwellEventCard = ({
  swellEvent,
  onClickCard
}) => /*#__PURE__*/React$1.createElement("a", {
  className: "quiver-swell-event-card",
  href: swellEvent.permalink,
  onClick: () => onClickCard(swellEvent)
}, /*#__PURE__*/React$1.createElement("div", {
  className: "quiver-swell-event-card__thumbnail"
}, /*#__PURE__*/React$1.createElement("div", {
  className: "quiver-swell-event-card__thumbnail__img",
  style: {
    backgroundImage: "url(".concat(swellEvent.thumbnailUrl, ")")
  }
})), /*#__PURE__*/React$1.createElement("div", {
  className: "quiver-swell-event-card__details"
}, swellEvent.titleTag && swellEvent.titleTag.toUpperCase() !== 'ALERT' ? /*#__PURE__*/React$1.createElement("div", {
  className: "quiver-swell-event-card__details__top"
}, /*#__PURE__*/React$1.createElement("div", {
  className: "quiver-swell-event-card__tag"
}, swellEvent.titleTag ? swellEvent.titleTag.toUpperCase() : 'SWELL ALERT'), /*#__PURE__*/React$1.createElement("span", {
  className: "quiver-swell-event-card__updated"
}, formatArticleDate(new Date(swellEvent.updatedAt) / 1000))) : null, /*#__PURE__*/React$1.createElement("div", {
  className: "quiver-swell-event-card__details__bottom"
}, /*#__PURE__*/React$1.createElement("div", {
  className: "quiver-swell-event-card__details__bottom__content"
}, /*#__PURE__*/React$1.createElement("h3", {
  className: "quiver-swell-event-card__title"
}, swellEvent.name), /*#__PURE__*/React$1.createElement("p", {
  className: "quiver-swell-event-card__summary"
}, swellEvent.summary), /*#__PURE__*/React$1.createElement("ul", {
  className: "quiver-swell-event-card__locations"
}, swellEvent.basins ? swellEvent.basins.map(basin => /*#__PURE__*/React$1.createElement("li", {
  className: "quiver-swell-event-card__locations__location",
  key: basin
}, formatBasinText(basin))) : null)))));

SwellEventCard.defaultProps = {
  onClickCard: () => {}
};

export default SwellEventCard;
//# sourceMappingURL=SwellEventCard.js.map
